import React, { useState, useEffect } from "react";
import FlashNewsGrid from "./FlashNewsGrid";
import FlashNewsForm from "./FlashNewsForm";
import ConfirmDialog from "../../../utils/ConfirmDialog"; // adjust path

const API_URL = "https://kvrstarlightmedicalacademy.com/api/flashnews.php";

const EditFlashNews = () => {
  const [newsList, setNewsList] = useState([]);
  const [view, setView] = useState("grid");
  const [editItem, setEditItem] = useState(null);
  const [deleteItem, setDeleteItem] = useState(null); // item selected for delete
  const [showConfirm, setShowConfirm] = useState(false);

  const token = localStorage.getItem("token");

  // Fetch on mount
  useEffect(() => {
    fetch(API_URL)
      .then((res) => res.json())
      .then((data) => setNewsList(data))
      .catch((err) => console.error("Fetch error:", err));
  }, []);

  const handleCreate = () => {
    setEditItem(null);
    setView("create");
  };

  const handleEdit = (item) => {
    setEditItem(item);
    setView("edit");
  };

  const askDelete = (item) => {
    setDeleteItem(item);
    setShowConfirm(true);
  };

  const confirmDelete = async () => {
    if (!deleteItem) return;
    try {
      await fetch(`${API_URL}?id=${deleteItem.id}`, {
        method: "DELETE",
        headers: { Authorization: `Bearer ${token}` },
      });
      setNewsList(newsList.filter((n) => n.id !== deleteItem.id));
    } catch (err) {
      console.error("Delete error:", err);
    } finally {
      setShowConfirm(false);
      setDeleteItem(null);
    }
  };

  const handleSubmit = async (newsText) => {
    try {
      if (editItem) {
        await fetch(`${API_URL}?id=${editItem.id}`, {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ flashnews: newsText }),
        });
        setNewsList(
          newsList.map((n) =>
            n.id === editItem.id ? { ...n, flashnews: newsText } : n
          )
        );
      } else {
        const res = await fetch(API_URL, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ flashnews: newsText }),
        });
        const data = await res.json();
        setNewsList([...newsList, { id: data.id, flashnews: newsText }]);
      }
    } catch (err) {
      console.error("Submit error:", err);
    }
    setView("grid");
  };

  const handleCancel = () => {
    setView("grid");
  };

  return (
    <div className="container mt-4">
      {view === "grid" && (
        <FlashNewsGrid
          data={newsList}
          onEdit={(index) => handleEdit(newsList[index])}
          onDelete={(index) => askDelete(newsList[index])}
          onCreate={handleCreate}
        />
      )}
      {(view === "create" || view === "edit") && (
        <FlashNewsForm
          initialValue={editItem ? editItem.flashnews : ""}
          onSubmit={handleSubmit}
          onCancel={handleCancel}
        />
      )}

      {showConfirm && (
        <ConfirmDialog
          message={`Are you sure you want to delete "${
            deleteItem?.flashnews || "this item"
          }"?`}
          onConfirm={confirmDelete}
          onCancel={() => setShowConfirm(false)}
        />
      )}
    </div>
  );
};

export default EditFlashNews;
